// spec/admin-ui/navigation.md: admin-ui-navigation-R18, R28–R32, R36–R39, R88.
import { createRouter, createWebHistory, type Router, type RouterHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { PRIVILEGES } from '@/types'

export const sections = [
  { path: '/resources', privilege: PRIVILEGES.RESOURCES },
  { path: '/execution_history', privilege: PRIVILEGES.HISTORY },
  { path: '/projects', privilege: PRIVILEGES.PROJECTS },
  { path: '/schedules', privilege: PRIVILEGES.SCHEDULES },
  { path: '/events_listeners', privilege: PRIVILEGES.EVENTS },
  { path: '/data_services', privilege: PRIVILEGES.DATA_SERVICES },
] as const
const routes: RouteRecordRaw[] = [
  { path: '/', name: 'home', component: () => import('@/views/NavigationStatusView.vue') },
  { path: '/resources', name: 'resources', component: () => import('@/views/ResourcesView.vue') },
  { path: '/execution_history', name: 'execution_history', component: () => import('@/views/ExecutionHistoryView.vue') },
  { path: '/projects', name: 'projects', component: () => import('@/views/ProjectsView.vue') },
  { path: '/schedules', name: 'schedules', component: () => import('@/views/SchedulesView.vue') },
  { path: '/events_listeners', name: 'listeners', component: () => import('@/views/EventsListenersView.vue') },
  { path: '/data_services', name: 'data_services', component: () => import('@/views/DataServicesView.vue') },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/views/NavigationStatusView.vue') },
]
export function createPanelRouter(history: RouterHistory = createWebHistory()): Router {
  const panel = createRouter({ history, routes })
  panel.beforeEach(async (to) => {
    const auth = useAuthStore()
    await auth.initialize(to.fullPath)
    if (auth.hasWorkspace && to.name === 'home') {
      const initial = sections.find((section) => auth.can(section.privilege))
      if (initial) return { path: initial.path, replace: true }
    }
    return true
  })
  return panel
}
export default createPanelRouter()
